import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createCircleNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;
const SIDE_CIRCLE_OFFSET = 12.4;
const SIDE_CIRCLE_RADIUS = 2.8;
const BIG_CIRCLE_RADIUS = 17.2;
const CENTER_CIRCLE_RADIUS = 4.8;
const RADIAL_LINE_OUTER_OFFSET = SIDE_CIRCLE_OFFSET - SIDE_CIRCLE_RADIUS;
const RADIAL_LINE_INNER_OFFSET = CENTER_CIRCLE_RADIUS;

function createCloudTransitHubIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const strokeOptions = {
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 0.8,
  };

  const drawTransitCircle = (cx: number, cy: number, r: number) =>
    makeTag('circle', {
      cx,
      cy,
      fill: 'none',
      r,
      ...strokeOptions,
    });

  const radials = makeTag('path', {
    d: new SvgPathBuilder()
      .moveTo(0, RADIAL_LINE_INNER_OFFSET)
      .vLineTo(RADIAL_LINE_OUTER_OFFSET)
      .moveTo(0, -RADIAL_LINE_INNER_OFFSET)
      .vLineTo(-RADIAL_LINE_OUTER_OFFSET)
      .moveTo(RADIAL_LINE_INNER_OFFSET, 0)
      .hLineTo(RADIAL_LINE_OUTER_OFFSET)
      .moveTo(-RADIAL_LINE_INNER_OFFSET, 0)
      .hLineTo(-RADIAL_LINE_OUTER_OFFSET)
      .build(),
    fill: 'none',
    ...strokeOptions,
  });

  const icon = `${drawCircleBackground(DIAMETER / 2, opts.style)}
    ${drawTransitCircle(0, 0, BIG_CIRCLE_RADIUS)}
    ${drawTransitCircle(0, 0, CENTER_CIRCLE_RADIUS)}
    ${drawTransitCircle(SIDE_CIRCLE_OFFSET, 0, SIDE_CIRCLE_RADIUS)}
    ${drawTransitCircle(-SIDE_CIRCLE_OFFSET, 0, SIDE_CIRCLE_RADIUS)}
    ${drawTransitCircle(0, SIDE_CIRCLE_OFFSET, SIDE_CIRCLE_RADIUS)}
    ${drawTransitCircle(0, -SIDE_CIRCLE_OFFSET, SIDE_CIRCLE_RADIUS)}
    ${radials}
  `;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudTransitHubIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudTransitHubIcon,
);
